var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotEyesInputCount = function SvgShotEyesInputCount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shotEyesInputCount_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shotEyesInputCount_svg__st0{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7h6M11.5 14V7.5M10.1 21H4c-.6 0-1-.4-1-1V3.5c0-.6.4-1 1-1h16c.6 0 1 .4 1 1v4.9M13.5 19l5.2-7.2 2.2 1.8-5.4 7.4h-2z",
    className: "shotEyesInputCount_svg__st0"
  })));
};
export default SvgShotEyesInputCount;